




















import { Vue, Component } from "vue-property-decorator";
import { State } from "vuex-class";
import { logout } from "@/http/login.api"
import { UserInterface } from "@/store/user";

@Component
export default class LoginLabel extends Vue {
  @State("User") User: any;
  get userInfo() {
    return this.User.user;
  }
  handleLogout(){
    logout();
    this.$store.commit('CLEAR_USER');
  }
  personCenter(){
    this.$router.push('/person-center')
  }
}
